"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DomestikaNextLiveCardDefaultProps = exports.DomestikaNextLiveCardPropTypes = exports.DomestikaNextLiveCard = exports.StyledCard = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _css = _interopRequireDefault(require("@styled-system/css"));

var _styledSystem = require("styled-system");

var _Card = require("../../atoms/Card");

var _DomestikaLiveCardImage = require("../../atoms/DomestikaLiveCardImage");

var _DomestikaLiveCardInfo = require("../../atoms/DomestikaLiveCardInfo");

var _DomestikaLiveCardSkeleton = require("../../atoms/DomestikaLiveCardSkeleton");

var _DropdownMenu = require("../../atoms/DropdownMenu");

var _Icon = require("../../atoms/Icon");

var _Icons = require("../../atoms/Icons");

var _Layout = require("../../atoms/Layout");

var _Typography = require("../../atoms/Typography");

var _Buttons = require("../../atoms/Buttons");

var _When = _interopRequireDefault(require("../../utils/When"));

var _withTooltip = require("../../HOC/withTooltip");

var _hooks = require("../../utils/hooks");

var _validate = require("./validate");

var StyledCard = (0, _styledComponents.default)(_Card.Card).withConfig({
  displayName: "DomestikaNextLiveCard__StyledCard",
  componentId: "sc-1fnqcig-0"
})({
  padding: '0',
  overflow: 'hidden',
  cursor: 'pointer'
}, (0, _styledSystem.variant)({
  prop: 'loading',
  variants: {
    true: {
      cursor: 'default'
    }
  }
}));
exports.StyledCard = StyledCard;
var StyledOverlay = (0, _styledComponents.default)(_Layout.Box).withConfig({
  displayName: "DomestikaNextLiveCard__StyledOverlay",
  componentId: "sc-1fnqcig-1"
})({
  width: '100%'
}, (0, _styledSystem.variant)({
  prop: 'overlayPosition',
  variants: {
    bottom: {
      background: 'linear-gradient(0deg, rgba(0, 0, 0, 0.75) 0%, rgba(0, 0, 0, 0) 100%)',
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'flex-end'
    },
    bottom_green: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'flex-end'
    },
    top: {
      height: ['100%', '164px', '180px', '204px'],
      background: 'linear-gradient(180deg, rgba(0, 0, 0, 0.75) 0%, rgba(0, 0, 0, 0) 100%)'
    }
  }
}));
var StyledHover = (0, _styledComponents.default)(_Layout.Flex).withConfig({
  displayName: "DomestikaNextLiveCard__StyledHover",
  componentId: "sc-1fnqcig-2"
})({
  zIndex: 20,
  width: '100%',
  height: '100%',
  transition: 'background-color .2s linear',
  backgroundColor: 'transparent',
  flexDirection: 'column',
  justifyContent: 'space-between',
  float: 'left'
}, (0, _css.default)({
  ':hover': {
    backgroundColor: 'ghosted.sonar.dark'
  }
}));
var StyledUpperElementsWrapper = (0, _styledComponents.default)(_Layout.Flex).withConfig({
  displayName: "DomestikaNextLiveCard__StyledUpperElementsWrapper",
  componentId: "sc-1fnqcig-3"
})((0, _css.default)({
  justifyContent: 'flex-end',
  paddingRight: [3, 4, 5],
  paddingTop: [3, 4, 5],
  zIndex: 40
}));
var StyledIconWrapper = (0, _styledComponents.default)(_Layout.Flex).withConfig({
  displayName: "DomestikaNextLiveCard__StyledIconWrapper",
  componentId: "sc-1fnqcig-4"
})({
  cursor: 'default',
  padding: '6px'
}, (0, _styledSystem.variant)({
  prop: 'rounded',
  variants: {
    true: {
      borderRadius: '50%'
    }
  }
}));
var StyledIcon = (0, _styledComponents.default)(_Icon.IconForm).withConfig({
  displayName: "DomestikaNextLiveCard__StyledIcon",
  componentId: "sc-1fnqcig-5"
})({
  fontSize: '20px',
  lineHeight: '20px'
});

var LockIcon = function LockIcon(props) {
  return _react.default.createElement(StyledIconWrapper, (0, _extends2.default)({
    backgroundColor: "coco",
    rounded: true
  }, props), _react.default.createElement(StyledIcon, null, _react.default.createElement(_Icons.Lock, null)));
};

var StudentIcon = function StudentIcon(props) {
  return _react.default.createElement(StyledIconWrapper, (0, _extends2.default)({
    backgroundColor: "quandog",
    rounded: true
  }, props), _react.default.createElement(StyledIcon, {
    color: "coco"
  }, _react.default.createElement(_Icons.Cap, null)));
};

var BottomAlert = function BottomAlert(_ref) {
  var alertMessage = _ref.alertMessage,
      buttonText = _ref.buttonText,
      buttonDisabled = _ref.buttonDisabled,
      props = (0, _objectWithoutProperties2.default)(_ref, ["alertMessage", "buttonText", "buttonDisabled"]);
  return _react.default.createElement(StyledOverlay, {
    display: ['none', 'block', 'block']
  }, _react.default.createElement(_Layout.Flex, (0, _extends2.default)({
    marginTop: 5,
    paddingX: [2, 5, 5],
    paddingY: [2, 4, 4],
    width: "100%",
    minHeight: "55px",
    justifyContent: "space-between",
    alignItems: "center"
  }, props), _react.default.createElement(_Typography.Text, {
    size: "tiny",
    color: "coco"
  }, alertMessage), _react.default.createElement(_Buttons.Button, {
    hollow: "secondary",
    size: "medium",
    buttonType: "secondary",
    disabled: buttonDisabled
  }, _react.default.createElement(_Typography.TextForm, {
    size: ['tiny', 'tiny', 'small'],
    fontWeight: "medium",
    color: "white"
  }, buttonText))));
};

var DomestikaNextLiveCard = function DomestikaNextLiveCard(_ref2) {
  var streamers = _ref2.streamers,
      liveInfo = _ref2.liveInfo,
      loading = _ref2.loading,
      isReadyToLive = _ref2.isReadyToLive,
      isNotYetReadyToLive = _ref2.isNotYetReadyToLive,
      footerMessage = _ref2.footerMessage,
      readyToLiveButtonText = _ref2.readyToLiveButtonText,
      locked = _ref2.locked,
      lockedTooltip = _ref2.lockedTooltip,
      student = _ref2.student,
      studentTooltip = _ref2.studentTooltip,
      showDropdownMenu = _ref2.showDropdownMenu,
      dropdownMenuOptions = _ref2.dropdownMenuOptions,
      onClick = _ref2.onClick,
      observerRootElement = _ref2.observerRootElement,
      lazyLoading = _ref2.lazyLoading,
      width = _ref2.width,
      height = _ref2.height;

  if (!loading) {
    (0, _validate.validate)({
      streamers: streamers,
      liveInfo: liveInfo,
      onClick: onClick,
      isReadyToLive: isReadyToLive,
      isNotYetReadyToLive: isNotYetReadyToLive,
      footerMessage: footerMessage,
      readyToLiveButtonText: readyToLiveButtonText,
      showDropdownMenu: showDropdownMenu,
      dropdownMenuOptions: dropdownMenuOptions
    });
  }

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      upperElementsWrapperMargin = _useState2[0],
      setUpperElementsWrapperMargin = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      bottomIcon = _useState4[0],
      setBottomIcon = _useState4[1];

  var _useLazyLoadElement = (0, _hooks.useLazyLoadElement)({
    lazyLoading: lazyLoading,
    rootElement: observerRootElement,
    rootMargin: '0px'
  }),
      isElementVisible = _useLazyLoadElement.isElementVisible,
      getElementRef = _useLazyLoadElement.getElementRef;

  var getUpperElementsWrapperRef = function getUpperElementsWrapperRef(node) {
    if (node !== null) {
      var nodeHeight = node.getBoundingClientRect().height;
      setUpperElementsWrapperMargin(nodeHeight * -1);
    }
  };

  var isLoadingState = function isLoadingState() {
    return loading || !isElementVisible;
  };

  (0, _react.useEffect)(function () {
    if (locked) {
      setBottomIcon(function () {
        return (0, _withTooltip.WithTooltip)(LockIcon, {
          position: 'left',
          message: lockedTooltip,
          id: 'dmstk-featured-live-lock-icon-tooltip'
        });
      });
    } else if (student) {
      setBottomIcon(function () {
        return (0, _withTooltip.WithTooltip)(StudentIcon, {
          position: 'left',
          message: studentTooltip,
          id: 'dmstk-featured-live-student-icon-tooltip'
        });
      });
    } else {
      setBottomIcon(null);
    }
  }, [locked, student]);
  return _react.default.createElement("div", {
    ref: getElementRef
  }, _react.default.createElement(StyledCard, {
    onClick: onClick,
    borderRadius: 4,
    width: width,
    height: height,
    loading: isLoadingState() ? 'true' : 'false'
  }, _react.default.createElement(_When.default, {
    condition: !!isLoadingState()
  }, function () {
    return _react.default.createElement(_Layout.Flex, {
      paddingX: [4, 5, 6],
      paddingY: [3, 5, 6],
      height: "100%",
      backgroundColor: "durian"
    }, _react.default.createElement(_DomestikaLiveCardSkeleton.DomestikaLiveCardSkeleton, {
      type: "complete",
      color: "langsat"
    }));
  }), _react.default.createElement(_When.default, {
    condition: !isLoadingState()
  }, function () {
    return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_DomestikaLiveCardImage.DomestikaLiveCardImage, {
      imageUrl: liveInfo === null || liveInfo === void 0 ? void 0 : liveInfo.coverUrl,
      lazyLoading: lazyLoading
    }), _react.default.createElement(StyledHover, null, _react.default.createElement(StyledOverlay, {
      overlayPosition: "top"
    }, _react.default.createElement(_When.default, {
      condition: showDropdownMenu
    }, function () {
      return _react.default.createElement(StyledUpperElementsWrapper, {
        ref: getUpperElementsWrapperRef
      }, _react.default.createElement(_DropdownMenu.DropdownMenu, {
        dropdownMenuOptions: dropdownMenuOptions
      }));
    }), _react.default.createElement(_Layout.Flex, {
      padding: [4, 5, 6],
      marginTop: "".concat(upperElementsWrapperMargin, "px"),
      style: {
        zIndex: 10
      }
    }, _react.default.createElement(_DomestikaLiveCardInfo.DomestikaLiveCardInfo, {
      liveInfo: liveInfo,
      streamers: streamers
    }))), _react.default.createElement(_When.default, {
      condition: !!bottomIcon
    }, function () {
      return _react.default.createElement(StyledOverlay, {
        overlayPosition: "bottom"
      }, _react.default.createElement(_Layout.Flex, {
        alignItems: "center",
        justifyContent: "flex-end",
        paddingRight: [4, 5, 6],
        paddingBottom: [4, 5, 6],
        style: {
          zIndex: 20
        }
      }, _react.default.createElement(_react.default.Fragment, null, bottomIcon())));
    }), _react.default.createElement(_When.default, {
      condition: isReadyToLive
    }, function () {
      return _react.default.createElement(StyledOverlay, {
        overlayPosition: "bottom_green"
      }, _react.default.createElement(BottomAlert, {
        alertMessage: footerMessage,
        buttonText: readyToLiveButtonText,
        backgroundColor: "manzana",
        buttonDisabled: false
      }));
    }), _react.default.createElement(_When.default, {
      condition: isNotYetReadyToLive
    }, function () {
      return _react.default.createElement(StyledOverlay, {
        overlayPosition: "bottom"
      }, _react.default.createElement(BottomAlert, {
        alertMessage: footerMessage,
        buttonText: readyToLiveButtonText,
        backgroundColor: "transparent",
        buttonDisabled: true
      }));
    })));
  })));
};

exports.DomestikaNextLiveCard = DomestikaNextLiveCard;
var DomestikaNextLiveCardPropTypes = {
  streamers: _propTypes.default.arrayOf(_propTypes.default.shape({
    avatar: _propTypes.default.string,
    name: _propTypes.default.string
  })),
  liveInfo: _propTypes.default.shape({
    scheduledAt: _propTypes.default.string,
    language: _propTypes.default.string,
    title: _propTypes.default.string,
    coverUrl: _propTypes.default.string
  }),
  loading: _propTypes.default.bool,
  isReadyToLive: _propTypes.default.bool,
  isNotYetReadyToLive: _propTypes.default.bool,
  footerMessage: _propTypes.default.string,
  readyToLiveButtonText: _propTypes.default.string,
  locked: _propTypes.default.bool,
  lockedTooltip: _propTypes.default.string,
  student: _propTypes.default.bool,
  studentTooltip: _propTypes.default.string,
  onClick: _propTypes.default.func,
  lazyLoading: _propTypes.default.bool,
  observerRootElement: _propTypes.default.node,
  showDropdownMenu: _propTypes.default.bool,
  dropdownMenuOptions: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    onClick: _propTypes.default.func
  })),
  width: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.string]),
  height: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.string])
};
exports.DomestikaNextLiveCardPropTypes = DomestikaNextLiveCardPropTypes;
var DomestikaNextLiveCardDefaultProps = {
  streamers: null,
  liveInfo: null,
  loading: false,
  isReadyToLive: false,
  isNotYetReadyToLive: false,
  footerMessage: '',
  readyToLiveButtonText: '',
  locked: false,
  lockedTooltip: '',
  student: false,
  studentTooltip: '',
  onClick: null,
  lazyLoading: false,
  observerRootElement: null,
  showDropdownMenu: false,
  dropdownMenuOptions: null,
  width: ['100%', '473px', '454px', '580px'],
  height: ['192px', '314px', '302px', '386px']
};
exports.DomestikaNextLiveCardDefaultProps = DomestikaNextLiveCardDefaultProps;
DomestikaNextLiveCard.defaultProps = DomestikaNextLiveCardDefaultProps;